'use client';

import React, { FC } from 'react';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '@/components/common/RichText';
import useFeature from '@/hooks/useFeature';
import styles from './PDPPromoText.module.scss';

const SHOW_MESSAGING = 'show-messaging';

export interface PDPPromoTextProps {
  content?: Document | null;
}

export const PDPPromoText: FC<PDPPromoTextProps> = ({ content }) => {
  const evergreenDiscountMessaging = useFeature('evergreen-discount-messaging');
  const showMessaging =
    String(evergreenDiscountMessaging).toLowerCase() === SHOW_MESSAGING;

  if (!content || !showMessaging) return null;

  return (
    <div className="bg-kelly-green-tint py-1 px-2 mt-4 text-center">
      <div className={styles.pdpPromoTextRichtext}>
        <RichText
          content={content as Document}
          classes="text-success text-base"
        />
      </div>
    </div>
  );
};
